module.exports = __webpack_public_path__ + "img/23.a0833cf9.webp";